/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Nav_No_Errors_FoundInputs */

const en_error_nav_no_errors_found = /** @type {(inputs: Error_Nav_No_Errors_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No errors found`)
};

const fr_error_nav_no_errors_found = /** @type {(inputs: Error_Nav_No_Errors_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune erreur trouvee`)
};

const de_error_nav_no_errors_found = /** @type {(inputs: Error_Nav_No_Errors_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es wurden keine Fehler gefunden`)
};

const it_error_nav_no_errors_found = /** @type {(inputs: Error_Nav_No_Errors_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun errore trovato`)
};

const ru_error_nav_no_errors_found = /** @type {(inputs: Error_Nav_No_Errors_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ошибок не обнаружено`)
};

const es_error_nav_no_errors_found = /** @type {(inputs: Error_Nav_No_Errors_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron errores`)
};

const zh_cn2_error_nav_no_errors_found = /** @type {(inputs: Error_Nav_No_Errors_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未发现错误`)
};

const ja_error_nav_no_errors_found = /** @type {(inputs: Error_Nav_No_Errors_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エラーは見つかりませんでした`)
};

const hi_error_nav_no_errors_found = /** @type {(inputs: Error_Nav_No_Errors_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई त्रुटि नहीं पाई गई`)
};

const pt_pt2_error_nav_no_errors_found = /** @type {(inputs: Error_Nav_No_Errors_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum erro encontrado`)
};

/**
* | output |
* | --- |
* | "No errors found" |
*
* @param {Error_Nav_No_Errors_FoundInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_no_errors_found = /** @type {((inputs?: Error_Nav_No_Errors_FoundInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_No_Errors_FoundInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_error_nav_no_errors_found(inputs)
	if (locale === "de") return de_error_nav_no_errors_found(inputs)
	if (locale === "it") return it_error_nav_no_errors_found(inputs)
	if (locale === "ru") return ru_error_nav_no_errors_found(inputs)
	if (locale === "es") return es_error_nav_no_errors_found(inputs)
	if (locale === "zh-CN") return zh_cn2_error_nav_no_errors_found(inputs)
	if (locale === "ja") return ja_error_nav_no_errors_found(inputs)
	if (locale === "hi") return hi_error_nav_no_errors_found(inputs)
	if (locale === "pt-PT") return pt_pt2_error_nav_no_errors_found(inputs)
	return en_error_nav_no_errors_found(inputs)
});